import { lighten, useTheme } from '@mui/material';
import { useMemo } from 'react';
import ChartLegends from '../common/ChartLegends/ChartLegends';
import { NivoGridContainer } from '../common/NivoGridContainer';
import AutoSizer from 'react-virtualized-auto-sizer';
import Flex from '@components/Flex/Flex';
import { BarChartProps } from './CalculatorLineChart.types';
import { useIntl } from 'react-intl';
import { Bar } from '@nivo/bar';

const CalculatorBarChart: React.FC<BarChartProps> = ({
  title,
  data,
  legendTranslationId,
  headerRight,
  colors,
  keys,
  ...restProps
}: BarChartProps) => {
  const theme = useTheme();
  const intl = useIntl();

  const chartKeys = keys ?? Object.keys(data[0]).slice(1, Object.keys(data[0]).length);
  const { sortedColors } = useMemo(() => {
    const sortedColors = chartKeys.map((_x, index) =>
      lighten(theme.palette.primary.main, (1 / chartKeys.length) * index)
    );
    return { sortedColors: sortedColors };
  }, [chartKeys, theme.palette.primary.main]);

  return (
    <NivoGridContainer>
      <Flex justifyContent='space-between' alignItems='baseline'>
        <ChartLegends
          title={title}
          data={chartKeys.map((x) => {
            return {
              id: intl.formatMessage({ id: `${legendTranslationId}.${x}` }),
              data: [],
            };
          })}
          colors={colors ?? sortedColors}
        />
        {headerRight ? headerRight : null}
      </Flex>
      <Flex flex='3 0 auto'>
        <AutoSizer>
          {({ height, width }) => (
            <Bar
              theme={{
                axis: {
                  ticks: {
                    line: {
                      stroke: theme.palette.grey[500],
                    },
                    text: {
                      fill: theme.palette.grey.A100,
                      fontWeight: 600,
                    },
                  },
                },
              }}
              keys={chartKeys}
              borderRadius={1}
              padding={0.25}
              margin={{
                top: 40,
                left: 20,
                right: 40,
                bottom: 40,
              }}
              data={data}
              valueScale={{ type: 'symlog' }}
              colors={colors ?? sortedColors}
              enableGridY
              axisBottom={{
                tickSize: 0,
                tickPadding: 14,
              }}
              valueFormat={(v) => ''}
              axisLeft={{
                legendOffset: 12,
                tickSize: 0,
              }}
              {...restProps}
              height={height}
              width={width}
            />
          )}
        </AutoSizer>
      </Flex>
    </NivoGridContainer>
  );
};

export default CalculatorBarChart;
